AoPS.Utils.initKeyChain(AoPS, "Ebooks", "Views", "Section");

AoPS.Ebooks.Views.Section = (function (EbkVSec) {
	// Dependencies
	var compileTemplate = AoPS.View.compileTemplate;
	var Feed = AoPS.Feed;
	var Ui = AoPS.Ui;
	var Modal = AoPS.Ui.Modal;
	var EbkVBase = AoPS.Ebooks.Views.Base;
	var EbkUrlMain = AoPS.Ebooks.Url.main;
	// Optional and allowed to be loaded before or after this file
	// AoPS.Ebooks.Admin.Section;

	function redrawEl($el) {
		var old_disp = $el.css("display");
		return $el.hide(0, function () {
			$(this).css("display", old_disp);
		});
	}

	function makeAopsVolNIcons(view, container_el) {
		_.each(container_el.find(".ebk-sb-inline-marker"), function (el) {
			el = $(el);
			var gutter_el = $("<img>").addClass("ebk-sb-right-icon");

			// Compute image URL. Done in separate closure for memory reasons.
			(function () {
				var image_url;
				if (el.hasClass("ebk-sb-inline-marker-warning")) {
					image_url = EbkUrlMain.getImage("aopsvoln-bomb.png");
				} else if (el.hasClass("ebk-sb-inline-marker-tough")) {
					image_url = EbkUrlMain.getImage("aopsvoln-needle.png");
				} else if (el.hasClass("ebk-sb-inline-marker-important")) {
					image_url = EbkUrlMain.getImage("aopsvoln-eyeball.png");
				} else {
					return;
				}
				gutter_el.attr("src", image_url);
			})();

			gutter_el.css("top", el.position().top);
			view.$el.prepend(gutter_el);

			// Things like rendering Latex or shown solutions might change where
			// this should go. Keep resetting the position.
			var interval_id = setInterval(function () {
				// Check if in DOM
				if (!el.parents("html").length) {
					clearInterval(interval_id);
					return;
				}
				gutter_el.css("top", el.position().top);
			}, 1000);
		});
	}

	function mangleDataHrefs(view, container_el) {
		var EbkAdmSec = AoPS.Ebooks.Admin && AoPS.Ebooks.Admin.Section;
		if (view.model.get("edge")) {
			return EbkAdmSec && EbkAdmSec.mangleDataHrefsEdge(view, container_el);
		}
		var book = view.model.get("book");

		function showPreviewModal() {
			EbkVBase.showFreePreviewModal("preview-cross-reference", book);
		}
		function setupPreviewLink(el) {
			el.attr(
				"title",
				"This is a hyperlink in the full ebook. The link is disabled in this preview."
			);
			el.click(showPreviewModal);
			el.removeAttr("data-href-section");
		}

		_.each(container_el.find("a[data-href-section]"), function (el) {
			el = $(el);
			var section_id = el.attr("data-href-section");
			var section_code = book.getFragmentCodeFromId(section_id);
			if (view.is_free_preview) {
				setupPreviewLink(el);
			} else {
				el.attr("href", view.url_table.getUrl("section", section_code));
				el.attr(view.stay_attr, "1");
			}
			el.removeAttr("data-href-section");
		});

		_.each(container_el.find("a[data-href-label]"), function (el) {
			el = $(el);
			var label_id = el.attr("data-href-label");
			if (view.is_free_preview) {
				setupPreviewLink(el);
			} else {
				el.attr("href", view.url_table.getUrl("label", label_id));
				el.attr(view.stay_attr, "1");
			}
			el.removeAttr("data-href-label");
		});
	}

	function makeSolnHideButtons(view, container_el) {
		var show_button = $(
			$.parseHTML('<div class="btn btn-primary">Show Solution</div>')
		);

		_.each(container_el.find(".ebk-sb-solution-hide"), function (el) {
			el = $(el);
			var my_button = show_button.clone();
			my_button.click(function () {
				my_button.hide();
				el.show();
			});
			el.before(my_button);
		});
	}

	function postprocess(view, container_el) {
		makeAopsVolNIcons(view, container_el);
		mangleDataHrefs(view, container_el);
		makeSolnHideButtons(view, container_el);
	}

	EbkVSec.Main = EbkVBase.BaseView.extend({
		initialize: function (options) {
			// No template: use a simple div with ebk-section-body class
			this.$el.addClass("ebk-section-body");

			this.url_table = options.url_table;
			this.stay_attr = options.stay_attr;
			this.is_free_preview = options.is_free_preview;
			this.full = options.full;

			this.listenTo(this, "show", this.attemptLoad);
			this.attemptLoad();

			var master = this.model.get("book").get("master");
			this.listenTo(master, "change:is_offline", this.onOfflineChange);

			this.renderLoading();
		},

		attemptLoad: function () {
			if (this.load_done) {
				this.model.markViewed();
				return;
			} else if (this.load_in_progress) {
				return;
			}

			this.load_in_progress = true;

			this.model.requestLoad(function (ok, data) {
				this.load_in_progress = false;
				this.load_done = true;
				if (!ok && data && data.error_code === "E_LOAD_INTERRUPT") {
					this.load_done = false;
					return;
				} else if (!ok) {
					return this.renderError(data);
				} else {
					this.render();
				}
			}, this);
		},

		// Not doing anything with templates/subviews, so overriding render
		render: function () {
			this.$el.empty();
			this.$el.html(this.model.get("html"));

			postprocess(this, this.$el);

			var EbkAdmSec = AoPS.Ebooks.Admin && AoPS.Ebooks.Admin.Section;
			if (EbkAdmSec) {
				EbkAdmSec.makeAdminBar(this);
				EbkAdmSec.setupAdminHacks(this);
			}

			this.manglePartBlocks();
			this.makeParAnchor();
			this.makeJumpButtons();
			this.makeFeedButtons();
			this.makeProbSubs();
			this.makeHints();
			this.makeVideos();
			if (this.full) {
				this.makeFooter();
			} else {
				this.makeFakeFooter();
			}
			this.setupLicenseModal();
			this.redrawLatex();

			// processShownObject uses scrollTop of the object to be shown, so we
			// have to call this after all the auxiliary elements are rendered.
			this.processShownObject(this.shown_obj);
			delete this.shown_obj;

			this.rendered = true;
		},

		reloadContent: function () {
			if (!this.model.reload) {
				return;
			}

			this.model.reload(function (ok, data) {
				if (!ok) {
					EbkVBase.showModalError("An error occurred while reloading.", data);
				}
				this.render();
			}, this);
			this.renderLoading();
		},

		// shown_obj can have label (an id), paragraph (an id), problem (an id),
		// and search keys.
		showObject: function (shown_obj) {
			if (!shown_obj) {
				return;
			} else if (this.rendered) {
				this.processShownObject(shown_obj);
			} else {
				// Save as an attribute to be processed in the render method later.
				this.shown_obj = shown_obj;
			}
		},

		makeFooter: function () {
			if (this.model.get("edge")) {
				return;
			}
			var model = this.model;

			function showPreviewModal() {
				EbkVBase.showFreePreviewModal("preview-footer-nav", model.get("book"));
			}

			function gotoSectionId(id) {
				$(window).scrollTop(0);
				Backbone.trigger("ebk_goto_section", model.get("book"), id);
			}

			var footerTpl = compileTemplate("#ebk-tpl-section-body-footer");
			var footer = $($.parseHTML(footerTpl()));

			var next_id = this.model.getRelativeSectionId("section", 1);
			var next_button = footer.find(".ebk--next");
			if (this.is_free_preview) {
				next_button.click(showPreviewModal);
			} else if (next_id) {
				next_button.click(_.partial(gotoSectionId, next_id));
			} else {
				next_button.hide();
			}

			var prev_id = this.model.getRelativeSectionId("section", -1);
			var prev_button = footer.find(".ebk--previous");
			if (this.is_free_preview) {
				prev_button.click(showPreviewModal);
			} else if (prev_id) {
				prev_button.click(_.partial(gotoSectionId, prev_id));
			} else {
				prev_button.hide();
			}

			footer.find(".ebk--top").click(function () {
				$(window).scrollTop(0);
			});

			this.$el.append(footer);
		},

		// Footers for EBook in class view -- reduced navigation
		makeFakeFooter: function () {
			var footerTpl = compileTemplate("#ebk-tpl-fake-section-body-footer");
			var footer = $($.parseHTML(footerTpl()));

			footer.find(".ebk--top").click(function () {
				$(window).scrollTop(0);
			});

			this.$el.append(footer);
		},

		processShownObject: function (shown_obj) {
			if (!shown_obj || this.model.get("edge")) {
				return;
			}

			var $search_el;
			if (shown_obj.search) {
				$search_el = this.locateSearchResult(shown_obj.search, $obj);
				this.highlightElement($search_el);
				return;
			}

			var $obj;
			var should_highlight = false;
			if (shown_obj.label_id) {
				$obj = this.$('a[data-labelid="' + shown_obj.label_id + '"]').first();
			} else if (shown_obj.paragraph_id) {
				$obj = this.$('p[data-parid="' + shown_obj.paragraph_id + '"]').first();
				should_highlight = true;
			} else if (shown_obj.problem_id) {
				$obj = this.$(
					'div[data-probid="' + shown_obj.problem_id + '"]'
				).first();
			}

			if ($obj && $obj.length) {
				var $scroll_inner = this.$el.parents(".aops-scroll-inner").first();
				if ($scroll_inner.length) {
					$scroll_inner.scrollTop(
						$scroll_inner.scrollTop() +
							$obj.offset().top -
							$scroll_inner.offset().top -
							100
					);
				} else {
					$(window).scrollTop($obj.offset().top - 100);
				}
				if (should_highlight) {
					this.highlightElement($obj);
				}
				setTimeout(function () {
					if ($scroll_inner.length) {
						$scroll_inner.scrollTop(
							$scroll_inner.scrollTop() +
								$obj.offset().top -
								$scroll_inner.offset().top -
								100
						);
					} else {
						$(window).scrollTop($obj.offset().top - 100);
					}
				}, 1000);
			}
		},

		// Used when dealing with searching
		highlightElement: function ($el) {
			if (!$el || !$el.length) {
				return;
			}
			if ($el.parents(".ebk-sb-example").length) {
				// White text here, so use a dark color (T7302)
				$el.css("background-color", "#F04B23");
			} else {
				$el.css("background-color", "#FF7");
			}
		},

		// nearby_el may be an element corresponding to a paragraph or label, if that
		// was provided with the search result. But it may be undefined.
		locateSearchResult: function (search, nearby_el) {
			// Function to change all blocks of white space to one space and trim
			function normalizeSpacing(s) {
				return _.compact(s.split(/\s/)).join(" ");
			}

			if (!nearby_el) {
				// Have to assume the whole section was referred to...
				return this.$(".ebk-sb-header").first();
			}

			var result_el = _.find(nearby_el.find("[data-def]"), function (el) {
				var def = $(el).attr("data-def");
				var entries = _.map(def.split(";"), normalizeSpacing);
				return _.contains(entries, search);
			});
			result_el = $(result_el);

			if (!result_el || !result_el.html().length) {
				return nearby_el;
			}
			return result_el;
		},

		// If a <part> tag contains only a block element like an equation or image
		// make that equation or image be inline-block. This is a huge hack, but...
		manglePartBlocks: function () {
			_.each(this.$(".ebk-sb-part-label"), function (el) {
				var next_el = $(el.nextSibling);
				var is_last = !next_el.next().length;
				el = $(el);

				function tweakVerticalAlign() {
					if (next_el.height() > 20) {
						next_el.css("vertical-align", "top");
					}
				}

				if (is_last && next_el.hasClass("latexcenter")) {
					next_el.css({
						display: "inline-block",
						padding: "0",
					});
					next_el.on("load", tweakVerticalAlign);
					setTimeout(tweakVerticalAlign, 5000);
				} else if (is_last && next_el.hasClass("ebk-sb-image")) {
					next_el.css({
						display: "inline-block",
						width: "99%",
					});
					next_el.on("load", tweakVerticalAlign);
					setTimeout(tweakVerticalAlign, 5000);
				}
			});
		},

		makeJumpButtons: function () {
			var jumpTpl = compileTemplate("#ebk-tpl-section-body-jump-button");

			_.each(
				this.$(".ebk-sb-preview"),
				_.bind(function (el) {
					el = $(el);
					var problem_id = el.attr("data-preview-probid");

					var main_example = this.$(
						'.ebk-sb-example[data-probid="' + problem_id + '"]'
					).first();
					if (!main_example.length) {
						return;
					}

					var jump = $($.parseHTML(jumpTpl()));
					jump.click(
						_.bind(function () {
							var $scroll_inner = this.$el
								.parents(".aops-scroll-inner")
								.first();
							if ($scroll_inner.length) {
								$scroll_inner.scrollTop(
									$scroll_inner.scrollTop() +
										main_example.offset().top -
										$scroll_inner.offset().top -
										100
								);
							} else {
								$(window).scrollTop(main_example.offset().top - 100);
							}
						}, this)
					);

					el.find(".ebk-sb--top-right").append(jump);
				}, this)
			);
		},

		makeFeedButtons: function () {
			if (!Feed) {
				return;
			}

			var book = this.model.get("book");

			function showPreviewModal() {
				EbkVBase.showFreePreviewModal("preview-community-problem", book);
			}

			function getPreviewButtons() {
				if (!AoPS.bd.is_community_active) {
					return [];
				}

				var open_feed = $("<div></div>")
					.text("t")
					.addClass("open-feed-btn")
					.click(showPreviewModal)
					.attr("title", "View discussions about this");
				var new_topic = $("<div></div>")
					.text("V")
					.addClass("new-topic-btn")
					.click(showPreviewModal)
					.attr("title", "Start topic about this");
				return [open_feed, new_topic];
			}

			// Given an element, either .ebk-sb-example or.ebk-sb-problem, determine
			// the tag with the problem number to attach to it.
			function getProblemTagFromEl(el) {
				if (el.hasClass("ebk-sb-example")) {
					return el.find(".ebk-sb-example-number").text().trim();
				}

				var number = el.find(".ebk-sb--number").text();
				number = number.replace(/:/g, "");
				if (/^(Problem|Exercise)/.test(number)) {
					return number;
				}
				if (el.hasClass("ebk-sb--exercise")) {
					return "Exercise " + number;
				} else {
					return "Problem " + number;
				}
			}

			_.each(
				this.$(".ebk-sb-problem, .ebk-sb-example"),
				function (el) {
					el = $(el);
					if (this.is_free_preview) {
						el.find(".ebk-sb--top-right").append(getPreviewButtons());
						return;
					}

					if (!AoPS.bd.is_community_active) {
						return;
					}

					var problem_id = el.attr("data-probid");
					if (!problem_id) {
						// Borrow the problem ID of the first part of the problem.
						problem_id = el
							.find("div[data-probid]")
							.first()
							.attr("data-probid");
						if (!problem_id) {
							return;
						}
					}

					var code = this.model.get("fragment_code");
					var main_url = this.url_table.getUrl(
						"section_problem",
						code,
						problem_id
					);
					var problem_tag = getProblemTagFromEl(el);
					var tags = this.model.getTags().concat([problem_tag]);

					var open_feed = Feed.buildOpenFeedButton({
						category_id: book.get("cmty_category_id"),
						subtitle: problem_tag,
						tag_text: main_url,
					});
					var new_topic = Feed.buildNewTopicButton({
						category_id: book.get("cmty_category_id"),
						tags: tags,
						linked_tag: problem_tag,
						target_url: main_url,
						target_text: problem_tag,
						subtitle: problem_tag,
						hidden_tags: [this.url_table.getUrl("section", code)],
					});

					el.find(".ebk-sb--top-right").append([open_feed, new_topic]);
				},
				this
			);
		},

		makeProbSubs: function () {
			if (this.model.get("edge")) {
				return;
			}

			var clear_div = $($.parseHTML('<div class="ebk-clear"></div>'));

			var makeSub = _.bind(function (el) {
				var problem_id = $(el).attr("data-probid");
				if (!problem_id) {
					return null;
				}
				var model = this.model.getOrCreateProblem(problem_id);
				return new EbkVSec.ProbSub({
					model: model,
					is_free_preview: this.is_free_preview,
					parent_view: this,
				});
			}, this);

			var no_sol_html =
				"<em>This problem is open-ended and has no provided solution, so you cannot submit work for it.</em>";
			_.each(
				this.$(".ebk-sb-problem.ebk-sb-problem-nosol"),
				function (el) {
					// Make sure no ID so the below things don't get tripped.
					$(el).attr("data-probid", "");
					$(el)
						.find(".ebk-sb--main")
						.append(clear_div.clone(), $($.parseHTML(no_sol_html)));
				},
				this
			);

			this.prob_subs = [];

			_.each(
				this.$(".ebk-sb-problem"),
				function (el) {
					var sub_box = makeSub(el);
					if (sub_box) {
						$(el).find(".ebk-sb--main").append(clear_div.clone(), sub_box.$el);
						this.prob_subs.push(sub_box);
					}
				},
				this
			);

			_.each(
				this.$(".ebk-sb-problem .ebk-sb-part"),
				function (el) {
					var sub_box = makeSub(el);
					if (sub_box) {
						$(el).after(clear_div.clone(), sub_box.$el);
						this.prob_subs.push(sub_box);
					}
				},
				this
			);
		},

		makeHints: function () {
			var $hints = this.$(".ebk-sb-hint");

			if (this.model.get("edge")) {
				return;
			}

			_.each(
				$hints,
				function (el) {
					var hint_id = $(el).attr("data-hintid");
					if (!hint_id) {
						return;
					}
					var model = this.model.getOrCreateHint(hint_id);
					var hint_view = new EbkVSec.Hint({
						model: model,
						is_free_preview: this.is_free_preview,
						parent_view: this,
					});
					$(el).replaceWith(hint_view.$el);
				},
				this
			);
		},

		makeVideos: function () {
			_.each(
				this.$(".ebk-sb-video-container"),
				function (el) {
					el = $(el);
					var model = new Backbone.Model({
						thumbnail_youtube_id: el.attr("data-youtubeid"),
						thumbnail_video_title: el.attr("data-videotitle"),
						thumbnail_video_id: el.attr("data-videoid"),
						thumbnail_video_url: el.attr("data-videourl"),
					});

					var view = new AoPS.Videos.Views.ThumbnailView({
						model: model,
					});
					view.render();
					view.$("a").attr("target", "_blank");

					var inside_el = $("<div></div>").addClass("links-thumbnail-panel");
					inside_el.append(view.$el);
					el.append(inside_el);
				},
				this
			);
		},

		makeParAnchor: function () {
			var $gutter = $(
				$.parseHTML('<div class="ebk-section-body-gutter"></div>')
			);
			this.$el.prepend($gutter);

			var anchor_view = new EbkVSec.ParAnchor({
				model: this.model.get("book"),
				edge: this.model.get("edge"),
				url_table: this.url_table,
				is_free_preview: this.is_free_preview,
				$par: null,
			});
			$gutter.append(anchor_view.$el);

			var pars = this.$(".ebk-sb-par-marker-container");
			pars.on("mouseenter", function (evt) {
				anchor_view.setParEl($(evt.currentTarget));
			});
			this.$el.on("mouseleave", function (evt) {
				anchor_view.setParEl(null);
			});
		},

		setupLicenseModal: function () {
			var book = this.model.get("book");
			this.$(".ebk-sb--show-license").click(function () {
				var suffix =
					"The Purchaser agreed to the terms of this Agreement on " +
					book.get("start_access_at");
				if (!book.get("start_access_at")) {
					suffix =
						"The Purchaser agreed to the terms of this Agreement at the time of purchase of this ebook license.";
				}

				var license =
					compileTemplate("#ebk-tpl-store-license")() + "<p>" + suffix + "</p>";
				Modal.showAlert(license, {scrollable: true});
			});
		},

		// Some browsers, like Chrome, can't seem to get the latexcenter and float
		// layout right the first time. Tricking them into redrawing everything
		// makes everything better.
		redrawLatex: function () {
			var all_latex = this.$(".latex, .latexcenter");
			var redrawAllOnce = function () {
				_.each(all_latex, function (el) {
					redrawEl($(el));
				});
			};
			// TODO: Never did find a good way to wait for all loading to finish
			// before triggering these kinds of fixes.
			setTimeout(redrawAllOnce, 100);
			setTimeout(redrawAllOnce, 500);
			setTimeout(redrawAllOnce, 1000);
		},

		onOfflineChange: function (master_model, is_offline) {
			EbkVBase.enableHrefs(this.$el, !is_offline);
		},
	});

	EbkVSec.Hint = EbkVBase.BaseView.extend({
		initialize: function (options) {
			this.setTemplateAndUseRootEl("ebk-tpl-section-body-hint");

			this.parent_view = options.parent_view;
			this.is_free_preview = options.is_free_preview;

			var master = this.model.get("book").get("master");
			this.listenTo(master, "change:is_offline", this.onOfflineChange);

			this.render();
		},

		getContext: function () {
			return {
				is_shown: this.model.get("is_shown"),
				hint_html: this.model.get("hint_html"),
			};
		},

		postRender: function () {
			if (this.parent_view) {
				postprocess(this.parent_view, this.$el);
			}

			this.$(".ebk-sb-show-hint").click(_.bind(this.onViewHint, this));
			this.$(".ebk-sb-hide-hint").click(_.bind(this.onHideHint, this));
		},

		onViewHint: function () {
			this.model.view(function (ok, data) {
				if (!ok) {
					EbkVBase.showModalError(
						"A problem occurred while fetching the hint.",
						data
					);
					return;
				}
				this.render();
			}, this);
		},

		onHideHint: function () {
			this.model.set("is_shown", false);
			this.render();
		},

		onOfflineChange: function (master_model, is_offline) {
			this.$(".ebk-sb-show-hint").toggle(
				!this.model.get("hint_html") && !is_offline
			);
		},
	});

	EbkVSec.ProbSub = EbkVBase.BaseView.extend({
		// Milliseconds to wait for no input before saving to server
		AUTOSAVE_DELAY: 1000,

		initialize: function (options) {
			this.setTemplateAndUseRootEl("ebk-tpl-section-body-prob-sub");

			this.parent_view = options.parent_view;
			this.is_free_preview = options.is_free_preview;

			if (this.parent_view) {
				this.listenTo(this.parent_view, "show", this.render);
			}

			var master = this.model.get("book").get("master");
			this.listenTo(master, "change:is_offline", this.onOfflineChange);

			this.render();
		},

		getContext: function () {
			var model = this.model;
			return {
				has_submitted: model.get("has_submitted"),
				has_soln_perms: model.get("has_soln_perms") || this.is_free_preview,
				submission_before: model.get("submission_before"),
				submission_before_html: model.get("submission_before_html"),
				submission_after: model.get("submission_after"),
				submission_after_html: model.get("submission_after_html"),
				solution_html: model.get("solution_html"),
				before_placeholder: "Type your solution, notes and/or work here.",
				after_placeholder: "You may type any additional notes you have here.",
				soln_denied:
					"You don't have permission to view the solution to " +
					"this problem.",
			};
		},

		postRender: function () {
			if (this.parent_view) {
				postprocess(this.parent_view, this.$el);
			}

			this.makeTextareaDynamic();

			var textarea = this.$("textarea");
			if (textarea.length) {
				this.updateButtonState();
				textarea.on("input", _.bind(this.onSubmissionChange, this));
			}

			this.$(".ebk-sb--save-status").hide();
			this.$(".ebk-sb--rendered-text-holder").hide();
			this.$(".ebk-sb--show-sol").click(_.bind(this.onShowSolution, this));
			this.$(".ebk-sb--hide-sol").click(_.bind(this.onHideSolution, this));
			this.$(".ebk-sb--reset").click(_.bind(this.onReset, this));
			this.toggleSolution(!!this.model.get("has_submitted"));

			if (!this.model.get("has_soln_perms") && !this.is_free_preview) {
				this.$(".ebk-sb--show-sol").text("Submit");
			}

			this.previewRenderedSubmission();
		},

		makeTextareaDynamic: function () {
			var textarea = this.$("textarea");
			if (!textarea.length) {
				return;
			}

			// Autoexpand the textarea only once it's in the DOM
			var check_dom_interval = setInterval(function () {
				if (textarea.parents("html").length > 0) {
					clearInterval(check_dom_interval);
					Ui.autoExpandTextarea(textarea);
				}
			}, 100);
		},

		updateButtonState: function () {
			var show_sol_button = this.$(".ebk-sb--show-sol");
			var reset_button = this.$(".ebk-sb--reset");

			this.submitWhenDisabled =
				this.submitWhenDisabled ||
				_.bind(function () {
					if (this.is_offline) {
						Modal.showAlert(
							"You cannot perform this action in offline mode. " +
								"If you have internet access right now, use the button in the top right " +
								"of the page to reenable this action."
						);
					} else {
						Modal.showAlert(
							"<p>You must type in a response for this problem before " +
								"the system will let you submit it or view its solution.</p>"
						);
					}
				}, this);

			var submission = this.$("textarea").val().trim();
			this.show_disabled =
				!this.model.get("has_submitted") && (!submission || !!this.is_offline);

			// Allow explanatory tooltip/modal for disabled buttons
			show_sol_button.toggleClass("disabled", this.show_disabled);
			show_sol_button.off("click", this.submitWhenDisabled);
			if (this.show_disabled) {
				show_sol_button.css("pointer-events", "auto");
				show_sol_button.attr(
					"title",
					this.is_offline
						? "You can't submit in offline mode."
						: "Please input a response first."
				);
				show_sol_button.on("click", this.submitWhenDisabled);
			} else {
				show_sol_button.css("pointer-events", "");
				show_sol_button.removeAttr("title");
			}

			reset_button.toggleClass("disabled", !!this.is_offline);
			if (this.is_offline) {
				reset_button.css("pointer-events", "auto");
				reset_button.attr("title", "You can't reset in offline mode.");
			} else {
				reset_button.css("pointer-events", "");
				reset_button.removeAttr("title");
			}
		},

		flashSavedIndicator: function () {
			var span = this.$(".ebk-sb--save-status");
			span.finish();
			span.show();
			setTimeout(function () {
				span.fadeOut();
			}, 1500);
		},

		previewRenderedSubmission: function () {
			var html = this.model.get("has_submitted")
					? this.model.get("submission_after_html")
					: this.model.get("submission_before_html"),
				$container = this.$(".ebk-sb--rendered-text-holder");

			if (_.isNull(html) || html === "") {
				$container.hide();
				return;
			}

			$container.html('<span class="ebk-sb--header">Preview:</span> ' + html);
			$container.show();
		},

		submitProblem: function (is_final) {
			if (this.is_offline) {
				return;
			}

			var error = this.is_free_preview
				? "loading the solution"
				: "saving your submission";
			function onSubmit(ok, data) {
				if (!ok) {
					if (data.error_code !== "E_AJAX_FILTERED") {
						EbkVBase.showModalError(
							"An error occurred while " + error + ".",
							data
						);
					}
					return;
				}
				if (is_final) {
					this.render();
					this.toggleSolution(true);
					this.$(".ebk-sb--rendered-text-holder").hide();
				} else {
					this.flashSavedIndicator();
					this.previewRenderedSubmission();
				}
			}

			if (this.is_free_preview && is_final) {
				this.model.viewPreviewSolution(
					this.$("textarea").val(),
					onSubmit,
					this
				);
			} else if (!this.is_free_preview) {
				this.model.submitProblem(
					this.$("textarea").val(),
					is_final,
					onSubmit,
					this
				);
			}
		},

		toggleSolution: function (show) {
			this.$(".ebk-sb--show-sol").toggle(!show);
			this.$(".ebk-sb--hide-sol").toggle(
				!!(show && this.model.get("has_soln_perms"))
			);
			this.$(".ebk-sb--reset").toggle(!!this.model.get("has_submitted"));
			this.$(".ebk-sb-user-sub-final").toggle(!!show);
			this.$(".ebk-sb-solution").toggle(!!show);
		},

		onSubmissionChange: function () {
			this.updateButtonState();

			// No autosaving in preview
			if (this.is_free_preview) {
				return;
			}

			// Autosave
			if (!this.delayedSubmit) {
				this.delayedSubmit = _.debounce(
					_.bind(this.submitProblem, this, false),
					this.AUTOSAVE_DELAY
				);
			}
			this.delayedSubmit();
		},

		onShowSolution: function () {
			if (this.show_disabled) {
				return;
			}

			if (this.model.get("has_submitted")) {
				this.toggleSolution(true);
			} else if (!this.is_offline) {
				this.submitProblem(true);
			}
		},

		onHideSolution: function () {
			this.toggleSolution(false);
		},

		onReset: function () {
			if (this.is_offline) {
				return;
			}

			function onReset(ok, data) {
				if (!ok) {
					return EbkVBase.showModalError(data);
				}
				this.render();
			}
			function onModalResponse(response) {
				if (!response) {
					return;
				} else if (this.is_free_preview) {
					this.model.resetProblemLocal(onReset, this);
				} else {
					this.model.resetProblem(onReset, this);
				}
			}

			Modal.showConfirm(
				"This will permanently remove your submissions and " +
					"hide the solution until your next submission. Are you sure?",
				_.bind(onModalResponse, this)
			);
		},

		onOfflineChange: function (master_model, is_offline) {
			this.is_offline = is_offline;
			this.updateButtonState();
		},
	});

	EbkVSec.ParAnchor = EbkVBase.BaseView.extend({
		initialize: function (options) {
			this.setTemplateAndUseRootEl("ebk-tpl-section-body-par-anchor");

			this.url_table = options.url_table;
			this.edge = options.edge;
			this.$par = options.$par;
			this.is_free_preview = options.is_free_preview;

			var master = this.model.get("master");
			this.listenTo(master, "change:is_offline", this.onOfflineChange);

			this.render();
		},

		postRender: function () {
			this.followPar();

			this.$el.off("click");
			this.$el.click(_.bind(this.onClick, this));
		},

		setParEl: function ($par) {
			this.$par = $par;
			this.render();
		},

		followPar: function () {
			var doFollow = _.bind(function () {
				var their_top = this.$par.offset().top;
				var parent_top = this.$el.offsetParent().offset().top;
				var their_h = this.$par.height();
				var my_h = this.$el.height();

				this.$el
					.show()
					.css("top", their_top - parent_top + their_h / 2 - my_h / 2 + "px");
			}, this);

			var in_doc =
				this.$par && $.contains(document.documentElement, this.$par[0]);
			if (in_doc && !this.is_offline) {
				// The positioning works better when called twice.
				doFollow();
				doFollow();
			} else {
				this.$el.hide();
			}
		},

		onOfflineChange: function (master_model, is_offline) {
			this.is_offline = is_offline;
			this.followPar();
		},

		onClick: function () {
			if (this.edge || !this.$par) {
				return;
			}

			if (this.is_free_preview) {
				EbkVBase.showFreePreviewModal("preview-paragraph-url", this.model);
				return;
			}

			var url_suffix = this.url_table.getUrl(
				"paragraph",
				this.$par.attr("data-parid")
			);
			var url = window.location.href.replace(
				/([^\/]+):\/\/([^\/]+)\/(.*)$/,
				"$1://$2" + url_suffix
			);
			var url_modal = new EbkVBase.CopyTextModal({
				description: "The URL for this paragraph is:",
				text: url,
			});
			url_modal.show();
		},
	});

	return EbkVSec;
})(AoPS.Ebooks.Views.Section);
